// Import model
import { FilterWoodCatalogItemRequest } from '../models/FilterWoodCatalogItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { WoodCatalogItemCondition } from '../models/WoodCatalogItemCondition';
import { WoodCatalogItemFields } from '../models/WoodCatalogItemFields';
import { WoodCatalogItemIndexedFields } from '../models/WoodCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { WoodCatalogItemConditionSerializer } from './WoodCatalogItemConditionSerializer';
import { WoodCatalogItemFieldsSerializer } from './WoodCatalogItemFieldsSerializer';
import { WoodCatalogItemIndexedFieldsSerializer } from './WoodCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterWoodCatalogItemRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterWoodCatalogItemRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterWoodCatalogItemRequest instance
   */
  static deserialize(json: string): FilterWoodCatalogItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterWoodCatalogItemRequest instance
   */
  static fromObject(obj: any): FilterWoodCatalogItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterWoodCatalogItemRequest');
    }


    const instance: FilterWoodCatalogItemRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as WoodCatalogItemIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as WoodCatalogItemFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        WoodCatalogItemConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterWoodCatalogItemRequest instances
   */
  static deserializeArray(json: string): FilterWoodCatalogItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterWoodCatalogItemRequest instance to a JSON string
   */
  static serialize(instance: FilterWoodCatalogItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterWoodCatalogItemRequest instance to a plain object
   */
  static toObject(instance: FilterWoodCatalogItemRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        WoodCatalogItemConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterWoodCatalogItemRequest instances to a JSON string
   */
  static serializeArray(instances: FilterWoodCatalogItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
